import { createFeatureSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";

/**
 * Selector for notification
 */
export const listNotification = createFeatureSelector<GenericStoreApiData>(
  AppSettings.KEY_NOTIFICATION
);
